//
//
//
//
//
//
//
//

    export default {
        data() {
            return {
                pickerListModel: [
                    ['小米', 'iPhone', '华为', '情怀', '三星', '其他', '不告诉你']
                ],
                pickerSelectModel: ['iPhone']
            }
        },
    }



// WEBPACK FOOTER //
// ./src/components/design/components/control/sy-picker.vue